<template>
  <el-row class="fullHeight">
    <el-row class="fullHeight-90">
      <el-col :span="12" class="fullHeight">
        <img src="../assets/class.jpg" class="fullHeight fullWidth">
      </el-col>
      <el-col :span="2">
        <span>&nbsp;</span>
      </el-col>
      <el-col :span="6" class="display-table-full-height">
        <el-row class="vertical-align-middle">
          <el-form :model="loginForm" ref="loginForm" class="backgroud-white">
            <el-row class="el-form-control">
              <div class="login-top">
                <img src="../assets/icon_login.png" style="width:20%">
                <div class="login-description">
                  <span>请登录速成账号预约观看视频</span>
                </div>
              </div>
            </el-row>
            <el-row class="el-form-control">
              <el-col :span="16" :offset="4">
                <el-form-item prop="name">
                  <el-input
                    @change="checkAllInputs"
                    placeholder="速成用户账号"
                    v-model="loginForm.name"
                    maxlength="11"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="el-form-control">
              <el-col :span="16" :offset="4">
                <el-form-item prop="password">
                  <el-input
                    @keyup.enter.native="login"
                    @change="checkAllInputs"
                    placeholder="账号密码"
                    type="password"
                    v-model="loginForm.password"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="el-form-control">
              <el-col :span="16" :offset="4">
                <el-button type="primary" class="login-btn" @click="login">登 录</el-button>
              </el-col>
            </el-row>
            <el-row class="el-form-control errorMessageContainer">
              <el-col :span="16" v-if="showError" :offset="4">
                <el-alert :closable="false" v-bind:title="errorMessage" type="error" show-icon></el-alert>
              </el-col>
            </el-row>
            <el-row>
              <span>&nbsp;</span>
            </el-row>
            <el-row>
              <el-col :span="16" :offset="4">
                <el-divider></el-divider>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16" :offset="4">
                <span class="login-forget-password-description">
                  如忘记密码，请进入
                  <a href="http://portal.speedupedu.com" target="_blank">速成学员中心</a>找回密码
                </span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16" :offset="4" style="margin-bottom:56px;">
                <span  v-if="global.checkDevice" class="login-forget-password-description cs-redLabel">
                  为防止设备验证失败，请关闭浏览器无痕模式
                </span>
                <span v-else>&nbsp;</span>
              </el-col>
            </el-row>
          </el-form>
        </el-row>
      </el-col>
    </el-row>
    <el-row class="footer-description">
      <el-col class="display-table-full-height">
        <el-row class="vertical-align-middle">
          <footer>
            <div>
              <span>©2019 版权归速成教育所有</span>
              <span>
                <a @click="openServiceTermsDialog">速成教育视频服务条款</a>
              </span>
            </div>
          </footer>
        </el-row>
      </el-col>
    </el-row>
    <termsOfServiceInfo
      :termsOfServiceVisible="termsOfServiceVisible"
      :studentVideoDurationText="studentVideoDurationText"
      @closeDialog="closeServiceTermsDialog"
      @onOk="confirmServiceTermsDialog"
    ></termsOfServiceInfo>
    <el-dialog
        v-if="wechatLoginVisible"
        title="验证微信"
        :center="true"
        :close-on-click-modal="false"
        :visible.sync="wechatLoginVisible"
        top="8vh"
      >
        <wechartLogin
          action="validation"
          @success="onWechartLoginSuccess"
          @fail="onWechartLoginFailed"
        ></wechartLogin>
      </el-dialog>
  </el-row>
</template>

<style lang="scss" scoped>
.display-table-full-height {
  display: table;
  height: 100%;
}
.vertical-align-middle {
  display: table-cell;
  vertical-align: middle;
}
.cs-content {
  background-color: #1c62c3;
}
.el-form-control {
  margin-bottom: 0px;
}
.login-top {
  text-align: center;
  margin-top: 50px;
  margin-bottom: 40px;
  .login-description {
    margin-top: 14px;
    color: lightgray;
  }
}
.login-btn {
  width: 100%;
  background-color: #1c62c3;
  border-radius: 3px;
  color: white;
}
.login-forget-password-description {
  color: black;
  font-size: 12px;
  a {
    text-decoration: underline;
  }

  &.cs-redLabel{
    color:red;
  }
}
.fullHeight {
  height: 100%;
}
.fullHeight-90 {
  height: 90%;
}
.fullWidth {
  width: 100%;
}
.footer-description {
  font-size: 12px;
  background-color: white;
  height: 10%;
  span {
    color: #b2b2b2;
    a {
      color: #1c62c3;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>

<script>
import platform from "platform";
import { userLogin, validateToken } from "../service/user.service";
import {
  setStore,
  saveUserInStore,
  getStore,
  isInRole,
  compileStr,
  checkUserWechatPass,
  clearUserInStore,
  saveUserWechatPassInStore,
  generateVisitorId,
  //getBrowerInfo
} from "../config/mUtils";
import { getWeChatConfig } from "../service/common.service";
import { getBlobStorageConfig } from "../service/blobStorage.service";
import { getStudentVideoDurationSettings } from "../service/student.service";
import global_ from "@/core/global";
import termsOfServiceInfo from "../components/termsOfServiceInfo";
import wechartLogin from "../components/common/wechartLogin";

export default {
  data() {
    return {
      studentVideoDurationSettings: [],
      studentVideoDurationText: "",
      wechatLoginVisible: false,
      global: global_,
      showError: false,
      errorMessage: "",
      btnClass: "info",
      termsOfServiceVisible: false,
      loginForm: {
        name: "",
        password: "",
        loginType: global_.loginType.student.name
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入速成用户账号",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          }
        ]
      }
    };
  },
  components: {
    termsOfServiceInfo,
    wechartLogin
  },
  created() {
    setStore("show-admin-hader", "true");
    this.$emit("page-changed-event", true);
    this.validateUserLogin();
  },
  methods: {
    onWechartLoginSuccess() {
      setTimeout(() => {
        this.wechatLoginVisible = false;

        saveUserWechatPassInStore();
        this.afterLogin();
      }, 2000);
    },
    onWechartLoginFailed(){
      clearUserInStore();
      this.wechatLoginVisible = false;
    },
    setWeChatConfig() {

      getWeChatConfig().then(result => {
        if (!!result && result.success) {
          let configureStr = compileStr(JSON.stringify(result.data));
          setStore("weChatConfig", configureStr);
          if (result.data.Enable){
            let user_student_hasWechat = getStore("user_student_hasWechat");
            if (user_student_hasWechat == "1"){
              this.wechatLoginVisible = true;
            }else{
              let msg = "请先在(https://portal.speedupedu.com)绑定真实的微信账号";
              this.$message({
                message:msg,
                type: "warning",
                duration: 0});
            }
          }else{
            this.afterLogin();
          }
        }
      });
    },
    setBlobStorageConfig() {
      getBlobStorageConfig().then(result => {
        if (!!result && result.success) {
          let configureStr = compileStr(JSON.stringify(result.data));
          setStore("blobStorageConfig", configureStr);
        }
      });
    },
    validateUserLogin() {
      // if (getStore("admin_auth_token") == null) {
      //   this.$router.push("/");
      // }
      let token = getStore("auth_token");
      let role = getStore("user_role");
      if (token && role) {
        validateToken().then(result => {
          if (result.success) {
            //this.setWeChatConfig();
            if (this.global.wechatEnable){
              let isUserWechatPass = checkUserWechatPass();
              if (isUserWechatPass){
                this.afterLogin();
              }
            }else{
              this.afterLogin();
            }
          }
        });
      }
    },
    afterLogin() {
      this.setBlobStorageConfig();

      let user_student_enable = getStore("user_student_enable");
      if (!isInRole(this.global.roleType.student.name)) {
        this.errorMessage = "当前登陆用户不是学生";
        this.showError = true;
      } else {
        this.openServiceTermsDialog();
      }
    },
    async login() {
      const deviceid = getStore("user_deviceid");
      if (!!this.$refs["loginForm"]) {
        let isValid = true;
        this.$refs["loginForm"].validate(valid => {
          if (valid) {
          } else {
            isValid = false;
          }
        });
        if (!isValid) {
          return false;
        }
        let deviceName = platform.toString()
        let result = await userLogin(
          this.loginForm.name,
          this.loginForm.password,
          this.loginForm.loginType,
          deviceid,
          deviceName
        );
        if (result) {
          if (!result.success) {
            this.errorMessage = result.message;
            this.showError = true;
          } else {
            saveUserInStore(result.data);

            if (this.global.wechatEnable){
              this.setWeChatConfig();
            }else{
              this.afterLogin();
            }
          }
        }
      }
    },
    checkAllInputs() {
      if (!!this.loginForm.name && !!this.loginForm.password) {
        this.btnClass = "primary";
      } else {
        this.btnClass = "info";
      }
    },
    async openServiceTermsDialog() {
      await this.loadStudentVideoDurationSettings();
      //this.termsOfServiceVisible = true;
      this.confirmServiceTermsDialog();
    },
    closeServiceTermsDialog() {
      this.termsOfServiceVisible = false;
    },
    confirmServiceTermsDialog() {
      this.termsOfServiceVisible = false;
      let isLogged = window.localStorage.getItem("user_name") !== null;
      if (isLogged) {
        let user_student_hasUnsignedContracts = getStore("user_student_hasUnsignedContracts");
        let href = "";
        if (user_student_hasUnsignedContracts == "1"){
          href = "/pendingContracts";
          //this.$router.push("/pendingContracts");
        }else{
          href = "/appointmentList";
          //this.$router.push("/appointmentList");
        }
        window.location.href = href;
      }
    },
    async loadStudentVideoDurationSettings(){
      let result = await getStudentVideoDurationSettings(null);
      this.studentVideoDurationSettings = result.data;
      this.studentVideoDurationText = this.getStudentVideoDurationText();
    },
    getStudentVideoDurationText(){
      let text = "";
      for(let i = 0; i < this.studentVideoDurationSettings.length; i ++){
        let item = this.studentVideoDurationSettings[i];
        if (text.length > 0){
          text += "/";
        }
        if (item.CourseType === 3){
          text += `职业培训:${item.WatchingDuration}倍`;
        }else{
          text += `${item.CourseCategoryText}:${item.WatchingDuration}倍`;
        }
      }
      return text;
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/page/login.vue